import React from 'react';
import Loadable from 'react-loadable';

import {IProps, ILoadedProps} from './interface';

import {getEmployeeInfo} from "./api";

import LoadableLoading from '../../components/LoadableLoading';

export const path = `/employee/:userId/`;
export const getPath = (userId: string) => `/employee/${userId}/`;

const PageEmployee: React.FC<IProps> = (props) => {
    // @ts-ignore
    const userId = props.match.params.userId;

    const loader = {
        page: () => import('./page'),
        i18n: () => import('./ru.json'),
        getEmployeeInfo: () => getEmployeeInfo(userId)
    };

    const LoadableMap = Loadable.Map({
        loader,
        loading: LoadableLoading,
        render(loaded: ILoadedProps, loadedProps): React.ReactNode {
            const Page = loaded.page.default;

            return (
                <Page
                    info={loaded.getEmployeeInfo}
                    i18n={loaded.i18n}
                    userId={userId}
                    {...props}
                    {...loadedProps}
                />
            )
        }
    })

    return (
        <LoadableMap {...props} />
    )
};

export default PageEmployee;
